import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHome,
    faSearch,
    faEllipsisH,
    faEye,
    faEdit,
    faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
    Breadcrumb,
    ButtonGroup,
    Button,
    InputGroup,
    Form,
    Card,
    Table,
    Dropdown,
    Spinner,
} from "@themesberg/react-bootstrap";
import { useHistory } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export default function TransaksiPage() {
    const history = useHistory();
    const [transaksiList, setTransaksiList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [userRole, setUserRole] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            alert("Sesi kamu telah berakhir, silakan login kembali.");
            history.push("/login");
            return;
        }

        try {
            const decoded = jwtDecode(token);

            if (decoded.exp * 1000 < Date.now()) {
                localStorage.removeItem("token");
                alert("Token kamu sudah kedaluwarsa, silakan login ulang.");
                history.push("/login");
                return;
            }

            setUserRole(decoded.role);
        } catch (err) {
            console.error("Token invalid:", err);
            localStorage.removeItem("token");
            history.push("/login");
        }
    }, [history]);

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-md-0">
                    <h4>Selamat Datang</h4>
                    <p className="mb-0">Data transaksi lengkap beserta user dan produk.</p>
                </div>
            </div>
        </>
    );
}
